import React, { useState } from 'react'
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom"
import { toast } from 'react-toastify'
import { api_url } from '../constant'

import logo from '../images/logo.png'

import background from "../images/background.png";
import ReactGA from "react-ga4";
import { Helmet } from "react-helmet";



import main from '../images/main.png'
import { useAuth } from '../store/authProvider'
var axios = require('axios');

function Signin(props) {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Signin Page",
  });
  var [phones, setPhone] = useState('')
  const [val, setVal] = useState(phones);
  const [password, setPassword] = useState('')
  const { isAuth, setToken } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  // var login = async () => {
  //   if (phones.startsWith('0')) {
  //     phones = phones.split('')
  //     phones[0] = '9'
  //     phones = phones.join('')
  //     phones = "+24" + phones
  //   }

  //   var data = JSON.stringify({ "phonenumber": phones, "password": password });

  //   const response = await fetch(api_url + "/auth/login",
  //     {
  //       method: "POST",
  //       body: data,
  //       headers: { 'Content-Type': 'application/json' }
  //     }
  //   ).then(res => res.json())
  //     .catch(function (error) {

  //       toast("الرجاء التأكد من البيانات", { type: "error" })
  //     });


  //   if (response.status > 201) {
  //     toast("  الرجاء التأكد من البيانات ", { type: "error" });
  //     return;
  //   }
  //   console.log("Response", response);
  //   setToken(response.access_token)
  //   localStorage.setItem("auth", true)
  //   localStorage.setItem("user_id", response.user_id)
  //   localStorage.setItem("isVerified", response.isVerified);

  //   if (location.state?.from) {
  //     navigate(location.state.from)

  //   }
  //   window.location.reload();

  //   // navigate("/home")
  // }
  const login = async () => {
    try {
      // Format phone number if it starts with 0
      let formattedPhone = phones;
      if (phones.startsWith('0')) {
        formattedPhone = "+249" + phones.substring(1);
      }

      const response = await fetch(api_url + "/auth/login", {
        method: "POST",
        body: JSON.stringify({
          phonenumber: formattedPhone,
          password: password
        }),
        headers: { 'Content-Type': 'application/json' }
      });

      const data = await response.json();

      if (!response.ok) {
        // Show Arabic error message regardless of backend response
        toast.error("رقم الهاتف أو كلمة المرور غير صحيحة", {
        });
        return;
      }

      // Successful login
      setToken(data.access_token);
      localStorage.setItem("auth", "true");
      localStorage.setItem("user_id", data.user_id);
      localStorage.setItem("type", data.type);
      localStorage.setItem("cooperativeType", data.cooperativeType);
      localStorage.setItem("isVerified", data.isVerified);

      if (location.state?.from) {
        navigate(location.state.from)

      }
      window.location.reload();

    } catch (error) {
      // Handle network errors or other exceptions
      toast.error("حدث خطأ أثناء محاولة تسجيل الدخول", {
      });
      console.error("Login error:", error);
    }
  };

    // Function to handle forget password - redirect to admin WhatsApp
  const handleForgetPassword = () => {
    // Admin WhatsApp number - replace with actual admin number
    const adminWhatsAppNumber = "249117028638"; // Replace with actual admin number
    
    // Message to send to admin
    const message = `مرحبا، أريد استعادة كلمة المرور لحسابي. رقم هاتفي: ${phones || 'لم يتم إدخاله'}`;
    
    // Encode the message for URL
    const encodedMessage = encodeURIComponent(message);
    
    // Create WhatsApp URL
    const whatsappUrl = `https://wa.me/${adminWhatsAppNumber}?text=${encodedMessage}`;
    
    // Open WhatsApp in new tab
    window.open(whatsappUrl, '_blank');
    
    // Show confirmation message
    toast.info("سيتم فتح واتساب للتواصل مع المسؤول لاستعادة كلمة المرور", {
      position: "top-center",
      autoClose: 5000,
    });
  };

  if (isAuth) {
    return <Navigate replace to="/"></Navigate>
  }

  return (
    <>
      <Helmet>
        ‍<title>تسجيل الدخول</title>‍
        <meta property="og:site_name" content="Mahsool" />
        <meta name="keywords" content="Mahsool" />
        <meta property="og:title" content="تسجيل الدخول" />
        <meta property="og:description" content="mahsool" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="flex bg-flipped-background  bg-no-repeat bg-right-bottom bg-60% lg:bg-50%">
        <div className="hidden lg:block">
          <img src={main} alt="" className="h-screen " />
        </div>

        <div className="w-full lg:w-auto lg:mx-auto">
          <div className="flex flex-col p-4 lg:p-0 lg:w-[26.313rem] gap-3 items-center justify-center h-screen mx-auto">
            <img src={logo} alt="" className="w-16 " />
            <div className="font-bold italic">
              بوابتك للمعلومات و الاسواق الزراعية
            </div>

            <div className=""></div>
            <div className="flex flex-col text-right  justify-center w-full lg:w-[26.313rem] ">
              <form id="phone" action="" className="flex flex-col gap-3 mb-3">
                <label className="font-bold">رقم الهاتف</label>

                <input
                  className="border-[#D1CFCF] border-2 rounded-[13.539px] h-[47px] w-full placeholder:font-medium placeholder:text-[#999797] placeholder:text-sm focus:bg-[#F1F1F1] focus:ring-0  focus:border-primary"
                  dir="rtl"
                  pattern="[+]*?[0-9]*"
                  value={val}
                  onChange={(e) => {
                    setPhone(e.target.value);
                    setVal((v) =>
                      e.target.validity.valid ? e.target.value : v
                    );
                  }}
                  placeholder="إدخل رقم الهاتف ( 09xxxxxx)"
                  type="text"
                />
              </form>
              <form id="phone" action="" className="flex flex-col gap-3">
                <label className="font-bold">كلمة المرور</label>
                <input
                  className="border-[#D1CFCF] border-2 rounded-[13.539px] h-[47px] w-full placeholder:font-medium placeholder:text-[#999797] placeholder:text-sm focus:bg-[#F1F1F1] focus:ring-0  focus:border-primary"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="أدخل كلمة المرور"
                  type="password"
                  dir="rtl"
                />

                 {/* Forget Password Link */}
                <div className="text-left mt-2">
                  <button
                    type="button"
                    onClick={handleForgetPassword}
                    className="text-primary hover:text-blue-700 text-sm font-medium underline transition-colors duration-200"
                  >
                    نسيت كلمة المرور؟
                  </button>
                </div>
              </form>
              <button
                onClick={() => login()}
                className="w-full h-[47px]  font-bold  text-white rounded-[13.539px] bg-primary"
              >
                تسجيل الدخول
              </button>
            </div>

            <div className=" relative flex flex-col w-full text-center gap-3">
              <p className="text-[#999797] text-sm">ليس لديك حساب ؟</p>
              <Link to="/signup">
                <button className="w-full h-[47px]  font-bold  text-primary border-primary border-2 rounded-[13.539px]">
                  إنشاء حساب
                </button>
              </Link>
              <p className="text-[#999797] text-sm">أو</p>
              <Link to="/">
                <button className="w-full h-[47px]  font-bold  text-primary border-primary border-2 rounded-[13.539px] ">
                  تسجيل دخول كزائر
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );


}

export default Signin